import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import Button from '../../shared/Button/Button'
import useAllSitePage from '../../hooks/useAllSitePage'
import './InfoCards.scss'

const InfoCardsItem = ({ innerData }) => {
  const pagesPath = useAllSitePage()
  const {
    allSitePage: matchPages
  } = pagesPath

  const backgroundStyle = {
    backgroundImage: `url(${innerData.backgroundImage?.url || 'none'})`
  }

  return innerData.visible && (
    <section className="col-lg-4 col-md-6 col-sm-12 mb-4 mb-md-0">
      <div
        className="info-cards-items"
        role="img"
        alt={innerData.backgroundImageName || ''}
        style={backgroundStyle}
      >
        <div className="info-cards-items_filter">
          <h3>{innerData.cardName}</h3>
          {innerData.content &&
            <ReactMarkdown children={innerData.content} />
          }
          {(innerData.p_ucc_microsite?.slug ||
            innerData.p_ucc_page?.slug ||
            innerData.p_ucc_career?.slug ||
            innerData.url) && (
              <Button
                classButton={`text-left button-form rounded-0`}
                button={
                  {
                    label: innerData.textButton ? innerData.textButton : innerData.url ? 'IR A SITIO' : 'VER MÁS',
                    ...innerData
                  }
                }
                customButton={{ variant: 'light_outline', size: "", shape: 'pill' }}
                classContainer="d-flex info-cards-items_button-style"
                matchPages={matchPages?.nodes}
              />
            )
          }
        </div>
      </div>
    </section>
  )
}

export default InfoCardsItem

InfoCardsItem.propTypes = {
  innerData: PropTypes.object
}